import { Injectable } from '@angular/core';

@Injectable()
export class EnvService {
  public fileMngt = 'https://psa-esign.teamwill-digital.com/api/1/odm-filemngt/file';
  public odmEsign = 'https://psa-esign.teamwill-digital.com/api/1/odm-esign/esign';

  constructor() { }
}
